import { request } from './request';

export const getCounts = () => {
  return request(`counts/all`);
};
